module.exports = __webpack_public_path__ + "static/media/sculpting_mask.64aabfbf.jpg";